import type { Asset } from '@schibsted-svp/svp-api-types';
import { getDateString, DATE_TIME_FORMAT } from 'lib/time';
import { getFullUsernameFromEmail, isEmail } from 'lib/email';

export function getStatusText(status: Asset['status']): string {
    if (status === 'active') {
        return `Published`;
    }
    if (status === 'inactive') {
        return 'Unpublished';
    }
    if (status === 'draft') {
        return 'Incoming';
    }
    return 'Ready to be published';
}

export function formatPublishedDate(published: number): string {
    return published && getDateString(published, DATE_TIME_FORMAT);
}

export function formatLastEditedBy(lastEditedBy: string): string {
    return isEmail(lastEditedBy) ? getFullUsernameFromEmail(lastEditedBy) : lastEditedBy;
}
